// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2028%2044%27%3E%3Cpath%20d%3D%27M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z%27%20fill%3D%27%23777777%27%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2028%2044%27%3E%3Cpath%20d%3D%27M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z%27%20fill%3D%27%23777777%27%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public//images/up-arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body,
html {
  width: 100%;
  height: 100%;
}

body,
p {
  color: #777;
  font: 400 1rem/1.75rem "Open Sans", sans-serif;
}

.buyuk-baslik {
  font: 400 1.125rem/1.875rem "Open Sans", sans-serif;
}

.kucuk-baslik {
  font: 400 0.875rem/1.5rem "Open Sans", sans-serif;
}

.p-baslik {
  margin-bottom: 4rem;
  text-align: center;
}

h1 {
  color: #333;
  font: 700 2.625rem/3.375rem "Open Sans", sans-serif;
}

h2 {
  color: #333;
  font: 700 2.125rem/2.75rem "Open Sans", sans-serif;
}

h3 {
  color: #333;
  font: 700 1.75rem/2.375rem "Open Sans", sans-serif;
}

h4 {
  color: #333;
  font: 700 1.25rem/1.75rem "Open Sans", sans-serif;
}

h5 {
  color: #333;
  font: 700 1.125rem/1.625rem "Open Sans", sans-serif;
}

h6 {
  color: #333;
  font: 700 1rem/1.5rem "Open Sans", sans-serif;
}

.gelistirici-yorumlari {
  font-style: italic;
}

.gelistici-ismi {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
}

.li-buyuk-bosluk li {
  margin-bottom: 0.625rem;
}

a {
  color: #555;
  text-decoration: underline;
}

a:hover {
  color: #555;
  text-decoration: underline;
}

a.red {
  color: #ff556e;
}

.genel-buton-solid {
  display: inline-block;
  padding: 1.1875rem 2.125rem 1.1875rem 2.125rem;
  border: 0.125rem solid #ff556e;
  border-radius: 2rem;
  background-color: #ff556e;
  color: #fff;
  font: 700 0.875rem/0 "Open Sans", sans-serif;
  text-decoration: none;
  transition: all 0.2s;
}

.genel-buton-solid:hover {
  border: 0.125rem solid #ff556e;
  background-color: transparent;
  color: #ff556e;
  text-decoration: none;
}

.buton-buyuk {
  display: inline-block;
  padding: 1.5rem 2.375rem 1.5rem 2.375rem;
  border: 0.125rem solid #ff556e;
  border-radius: 2rem;
  background-color: #ff556e;
  color: #fff;
  font: 700 0.875rem/0 "Open Sans", sans-serif;
  text-decoration: none;
  transition: all 0.2s;
}

.buton-buyuk:hover {
  border: 0.125rem solid #ff556e;
  background-color: transparent;
  color: #ff556e;
  text-decoration: none;
}

.buton-buyuk .fab {
  margin-right: 0.5rem;
  font-size: 1.25rem;
  line-height: 0;
  vertical-align: top;
}

.buton-buyuk .fab.fa-google-play {
  font-size: 1rem;
}

.buton-cizgili {
  display: inline-block;
  padding: 1.1875rem 2.125rem 1.1875rem 2.125rem;
  border: 0.125rem solid #333;
  border-radius: 2rem;
  background-color: transparent;
  color: #333;
  font: 700 0.875rem/0 "Open Sans", sans-serif;
  text-decoration: none;
  transition: all 0.2s;
}

.buton-cizgili:hover {
  border: 0.125rem solid #333;
  background-color: #333;
  color: #fff;
  text-decoration: none;
}


.buton-cizgili-kucuk {
  display: inline-block;
  padding: 1rem 1.5rem 1rem 1.5rem;
  border: 0.125rem solid #333;
  border-radius: 2rem;
  background-color: transparent;
  color: #333;
  font: 700 0.875rem/0 "Open Sans", sans-serif;
  text-decoration: none;
  transition: all 0.2s;
}

.buton-cizgili-kucuk:hover {
  border: 0.125rem solid #333;
  background-color: #333;
  color: #fff;
  text-decoration: none;
}

.form-group {
  position: relative;
  margin-bottom: 1.25rem;
}

.form-group.has-error.has-danger {
  margin-bottom: 0.625rem;
}


.my-mfp-slide-bottom .zoom-anim-dialog {
  opacity: 0;
  transition: all 0.2s ease-out;
  transform: translateY(-1.25rem) perspective(37.5rem) rotateX(10deg);
}

.my-mfp-slide-bottom.mfp-ready .zoom-anim-dialog {
  opacity: 1;
  transform: translateY(0) perspective(37.5rem) rotateX(0);
}

.my-mfp-slide-bottom.mfp-removing .zoom-anim-dialog {
  opacity: 0;
  transform: translateY(-0.625rem) perspective(37.5rem) rotateX(10deg);
}

.my-mfp-slide-bottom.mfp-bg {
  opacity: 0;
  transition: opacity 0.2s ease-out;
}

.my-mfp-slide-bottom.mfp-ready.mfp-bg {
  opacity: 0.8;
}
.my-mfp-slide-bottom.mfp-removing.mfp-bg {
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fadeIn {
  animation: fadeIn 0.6s;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fadeOut {
  animation: fadeOut 0.8s;
}
.spinner-wrapper {
  position: fixed;
  z-index: 999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #f7fafd;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3.75rem;
  height: 1.25rem;
  margin: -0.625rem 0 0 -1.875rem;
  text-align: center;
}

.spinner > div {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  background-color: #ff556e;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.ustmenu-default {
  background-color: #f7fafd;
  box-shadow: 0 0.0625rem 0.375rem 0 rgba(0, 0, 0, 0.1);
  font: 700 0.875rem/0.875rem "Open Sans", sans-serif;
  transition: all 0.2s;
}

.ustmenu-default .navbar-brand.logo-image img {
  width: 6.6875rem;
  height: 2.25rem;
}

.ustmenu-default .navbar-brand.logo-text {
  font: 700 2rem/1rem "Open Sans", sans-serif;
  color: #333;
  text-decoration: none;
}

.ustmenu-default .navbar-nav {
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
}

.ustmenu-default .nav-item .nav-link {
  padding: 0.625rem 0.75rem;
  color: #333;
  text-decoration: none;
  transition: all 0.2s ease;
}

.ustmenu-default .nav-item .nav-link:hover,
.ustmenu-default .nav-item .nav-link.active {
  color: #ff556e;
}

.ustmenu-default .dropdown:hover > .dropdown-menu {
  display: block; 
  min-width: auto;
  animation: fadeDropdown 0.2s; 
}

@keyframes fadeDropdown {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.ustmenu-default .dropdown-toggle {
  cursor: default;
}

.ustmenu-default .dropdown-toggle:focus {
  outline: 0;
}

.ustmenu-default .dropdown-menu {
  margin-top: 0;
  border: none;
  border-radius: 0.25rem;
  background-color: #f7fafd;
}

.ustmenu-default .dropdown-item {
  color: #333;
  text-decoration: none;
}

.ustmenu-default .dropdown-item:hover {
  background-color: #f7fafd;
}

.ustmenu-default .dropdown-item .item-text {
  font: 700 0.875rem/0.875rem "Open Sans", sans-serif;
}

.ustmenu-default .dropdown-item:hover .item-text {
  color: #ff556e;
}

.ustmenu-default .dropdown-divider {
  width: 100%;
  height: 1px;
  margin: 0.75rem auto 0.725rem auto;
  border: none;
  background-color: #c4d8dc;
  opacity: 0.2;
}

.ustmenu-default .nav-item .buton-cizgili-kucuk {
  margin-top: 0.125rem;
  margin-bottom: 1.375rem;
  margin-left: 0.5rem;
  border: 0.125rem solid #ff556e;
  color: #ff556e;
}

.ustmenu-default .nav-item .buton-cizgili-kucuk:hover {
  border: 0.125rem solid #ff556e;
  background-color: #ff556e;
  color: #fff;
}

.ustmenu-default .navbar-toggler {
  padding: 0;
  border: none;
  color: #333;
  font-size: 2rem;
}

.ustmenu-default
  button[aria-expanded="false"]
  .ustmenu-ackapa-fw.fas.fa-times {
  display: none;
}

.ustmenu-default
  button[aria-expanded="false"]
  .ustmenu-ackapa-fw.fas.fa-bars {
  display: inline-block;
}

.ustmenu-default
  button[aria-expanded="true"]
  .ustmenu-ackapa-fw.fas.fa-bars {
  display: none;
}

.ustmenu-default
  button[aria-expanded="true"]
  .ustmenu-ackapa-fw.fas.fa-times {
  display: inline-block;
  margin-right: 0.125rem;
}

.header {
  position: relative;
  overflow: hidden;
  padding-top: 8rem;
  padding-bottom: 3rem;
  background-color: #f7fafd;
  text-align: center;
}

.header .metin-kutusu {
  margin-bottom: 3rem;
}

.header h1 {
  margin-bottom: 1rem;
}

.header .p-baslik {
  margin-bottom: 2rem;
}

.header .buton-buyuk {
  margin-right: 0.5rem;
  margin-bottom: 1.125rem;
  margin-left: 0.5rem;
}

.header .beyaz-halka,
.header .beyaz-halka-2,
.header .mavi-halka,
.header .sari-halka,
.header .gr-dia-halka {
  display: none;
}


.kart-1 {
  padding-top: 1rem;
  padding-bottom: 2rem;
  background-color: #f7fafd;
  text-align: center;
}

.kart-1 .card {
  max-width: 11rem;
  margin-right: auto;
  margin-bottom: 3rem;
  margin-left: auto;
  padding: 0;
  border: none;
  background-color: transparent;
}

.kart-1 .kart-resmi {
  width: 7.5rem;
  height: 7.5rem;
  margin-right: auto;
  margin-bottom: 1.5rem;
  margin-left: auto;
  border-radius: 50%;
  background-color: #ebe7fa;
}

.kart-1 .kart-resmi .fas {
  color: #aa7eec;
  font-size: 3.25rem;
  line-height: 7.5rem;
}

.kart-1 .kart-resmi.green {
  background-color: #daf4ef;
}

.kart-1 .kart-resmi.green .fas {
  color: #19ca94;
}

.kart-1 .kart-resmi.red {
  background-color: #f8e5ea;
}

.kart-1 .kart-resmi.red .fas {
  color: #ff556e;
}

.kart-1 .kart-resmi.yellow {
  background-color: #f8f1de;
}

.kart-1 .kart-resmi.yellow .fas {
  color: #ffb30f;
}

.kart-1 .kart-resmi.blue {
  background-color: #e1f2fa;
}

.kart-1 .kart-resmi.blue .fas {
  color: #50b9e8;
}

.kart-1 .card-body {
  padding: 0;
}

.kart-1 .card-title {
  margin-bottom: 0.5rem;
}


.temel {
  padding-top: 3rem;
  padding-bottom: 8rem;
  background-color: #f7fafd;
}

.temel .resim-kutusu {
  margin-bottom: 5rem;
}

.temel h2 {
  margin-bottom: 1.5rem;
}

.temel .liste-stili {
  margin-bottom: 1.75rem;
}

.temel .liste-stili .fas {
  color: #777;
  font-size: 0.5rem;
  line-height: 1.75rem;
}

.temel .liste-stili .media-body {
  margin-left: 0.5rem;
}

.basit-acik-kutu {
  position: relative;
  max-width: 71.875rem;
  margin: 2.5rem auto;
  padding: 3rem 1rem;
  background-color: #fff;
  text-align: left;
}

.basit-acik-kutu .resim-kutusu {
  margin-bottom: 3rem;
  text-align: center;
}

.basit-acik-kutu h3 {
  margin-bottom: 0.5rem;
}

.basit-acik-kutu hr {
  width: 2.75rem;
  margin-top: 0.125rem;
  margin-bottom: 1rem;
  margin-left: 0;
  border-top: 0.125rem solid #e0e0e0;
}

.basit-acik-kutu h4 {
  margin-top: 1.75rem;
  margin-bottom: 0.625rem;
}

.basit-acik-kutu .liste-stili {
  margin-bottom: 1.5rem;
}

.basit-acik-kutu .liste-stili .far {
  color: #19ca94;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.basit-acik-kutu .liste-stili .media-body {
  margin-left: 0.625rem;
}

.basit-acik-kutu .liste-stili {
  margin-bottom: 1.5rem;
}

.basit-acik-kutu .genel-buton-solid.mfp-close {
  position: relative;
  width: auto;
  height: auto;
  color: #fff;
  opacity: 1;
}

.basit-acik-kutu .genel-buton-solid.mfp-close:hover {
  color: #ff556e;
}

.tabs {
  padding-top: 8rem;
  padding-bottom: 8rem;
  background-color: #e8eff6;
}

.tabs .tabs-container {
  margin-bottom: 5rem;
}

.tabs .nav-tabs {
  margin-bottom: 1.125rem;
  border: none;
}

.tabs .nav-item {
  width: 100%;
  margin-bottom: 0.75rem;
  text-align: center;
}

.tabs .nav-link {
  padding: 0.5rem 1.5rem;
  border-radius: 0;
  background-color: #f7fafd;
  color: #777;
  font-weight: 700;
  font-size: 1.125rem;
  text-decoration: none;
  transition: all 0.2s ease;
}

.tabs .nav-link.active {
  background-color: #9a67e7;
  color: #fff;
}

.tabs .nav-link:hover {
  background-color: #9a67e7;
  color: #fff;
}

.tabs .nav-link .fas,
.tabs .nav-link .far {
  margin-right: 0.375rem;
}

.tabs .li-buyuk-bosluk li {
  margin-bottom: 0.875rem;
}

.tabs .liste-stili .fas,
.tabs .liste-stili .far {
  color: #19ca94;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.tabs .liste-stili .media-body {
  margin-left: 0.625rem;
}

.tabs #tab-1 .liste-stili {
  margin-bottom: 1.5rem;
}

.tabs #tab-1 .genel-buton-solid {
  margin-right: 0.5rem;
}


.basic-2 {
  padding-top: 7rem;
  padding-bottom: 5rem;
  background-color: #f7fafd;
}

.basic-2 h2 {
  margin-bottom: 0.875rem;
  text-align: center;
}

.basic-2 .li-buyuk-bosluk li {
  margin-bottom: 1.375rem;
}

.basic-2 .li-buyuk-bosluk.first li:last-of-type {
  margin-bottom: 4rem;
}

.basic-2 .fa-stack {
  width: 2em;
  margin-right: 0.625rem;
  font-size: 1.25rem;
}

.basic-2 .fa-stack-2x {
  color: #aa7eec;
}

.basic-2 .fa-stack-2x.green {
  color: #19ca94;
}

.basic-2 .fa-stack-2x.red {
  color: #ff556e;
}

.basic-2 .fa-stack-2x.yellow {
  color: #ffb30f;
}

.basic-2 .fa-stack-2x.blue {
  color: #50b9e8;
}

.basic-2 .fa-stack-1x {
  color: #fff;
}

.basic-2 .media-body h4 {
  margin-bottom: 0.25rem;
}

.basic-2 img {
  display: block;
  width: 100%;
  max-width: 20rem;
  margin-right: auto;
  margin-bottom: 5rem;
  margin-left: auto;
}


.slider {
  padding-top: 8rem;
  padding-bottom: 8rem;
  background-color: #e8eff6;
}

.slider .slider-container {
  position: relative;
}

.slider .swiper-container {
  position: static;
  width: 90%;
  text-align: center;
}

.slider .swiper-button-prev,
.slider .swiper-button-next {
  top: 50%;
  width: 1.125rem;
}

.slider .swiper-button-prev:focus,
.slider .swiper-button-next:focus {
  outline: none;
}

.slider .swiper-button-prev {
  left: -0.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 1.125rem 1.75rem;
}

.slider .swiper-button-next {
  right: -0.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 1.125rem 1.75rem;
}

.cards-2 {
  padding-top: 7rem;
  padding-bottom: 3rem;
  background-color: #f7fafd;
  text-align: center;
}

.cards-2 h2 {
  margin-bottom: 3.25rem;
}

.cards-2 .card {
  max-width: 22rem;
  margin-right: auto;
  margin-bottom: 4.75rem;
  margin-left: auto;
  border: 0;
  background-color: transparent;
}

.cards-2 .fa-star {
  margin-right: 0.25rem;
  color: #ffb30f;
  font-size: 1.375rem;
}

.cards-2 .testimonial-line {
  width: 3rem;
  margin-bottom: 1rem;
  border-top: 0.125rem solid #e0e0e0;
}

.cards-2 .card-body {
  padding: 0;
}

.cards-2 .gelistirici-yorumlari {
  margin-bottom: 0.625rem;
}

.cards-2 .gelistici-ismi {
  color: #333;
}

.cards-2 .resim-kutusu {
  margin-bottom: 5.25rem;
  padding: 2.5rem 2rem 0 2rem;
  border-radius: 0.5rem;
  background-color: #fff;
}

.cards-2 .resim-kutusu img {
  margin-right: 1rem;
  margin-bottom: 2.5rem;
  margin-left: 1rem;
}


.counter {
  padding-top: 8rem;
  padding-bottom: 5rem;
  background-color: #e8eff6;
  text-align: center;
}

.counter #counter {
  margin-bottom: 0.75rem;
}

.counter #counter .cell {
  display: inline-block;
  width: 6.25rem;
  margin-right: 1.5rem;
  margin-bottom: 2rem;
  margin-left: 1.5rem;
  vertical-align: top;
}

.counter #counter .fas {
  margin-bottom: 0.875rem;
  font-size: 2.5rem;
  color: #aa7eec;
}

.counter #counter .fas.green {
  color: #19ca94;
}

.counter #counter .fas.red {
  color: #ff556e;
}

.counter #counter .fas.yellow {
  color: #ffb30f;
}

.counter #counter .fas.blue {
  color: #50b9e8;
}

.counter #counter .counter-value {
  color: #333;
  font-weight: 700;
  font-size: 3.5rem;
  line-height: 4.25rem;
  vertical-align: middle;
}

.counter #counter .counter-info {
  margin-bottom: 0;
  vertical-align: middle;
}

.basic-3 {
  position: relative;
  overflow: hidden;
  padding-top: 8rem;
  padding-bottom: 8rem;
  background-color: #f7fafd;
  text-align: center;
}

.basic-3 .resim-kutusu {
  margin-bottom: 2rem;
}

.basic-3 .buyuk-baslik {
  margin-bottom: 1.75rem;
}

.basic-3 .buton-buyuk {
  margin-right: 0.5rem;
  margin-bottom: 1.125rem;
  margin-left: 0.5rem;
}

.basic-3 .beyaz-halka,
.basic-3 .beyaz-halka-2,
.basic-3 .mavi-halka,
.basic-3 .sari-halka,
.basic-3 .gr-dia-halka {
  display: none;
}


.footer {
  padding-top: 4rem;
  padding-bottom: 1rem;
  border-top: 1px solid #c8d4d6;
  background-color: #f7fafd;
}

.footer p,
.footer h5,
.footer ul,
.footer a {
  color: #999;
}

.footer a {
  text-decoration: none;
}

.footer .footer-col {
  display: inline-block;
  width: 14.5rem;
  margin-right: 1rem;
  margin-bottom: 1.5rem;
  vertical-align: top;
}

.footer h5 {
  margin-bottom: 0.625rem;
}

.footer .li-buyuk-bosluk li {
  margin-bottom: 0.375rem;
}

.footer .liste-stili .fab,
.footer .liste-stili .fas {
  width: 0.875rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.footer .liste-stili .media-body {
  margin-left: 0.625rem;
}

.footer .fa-stack {
  width: 2em;
  margin-bottom: 0.75rem;
  margin-right: 0.375rem;
  font-size: 1.25rem;
}

.footer .fa-stack .fa-stack-1x {
  color: #fff;
  transition: all 0.2s ease;
}

.footer .fa-stack .fa-stack-2x {
  color: #999;
  transition: all 0.2s ease;
}

.footer .fa-stack:hover .fa-stack-1x {
  color: #fff;
}

.footer .fa-stack:hover .fa-stack-2x {
  color: #555;
}


.copyright {
  padding-bottom: 0.75rem;
  background-color: #f7fafd;
  text-align: center;
}

.copyright p,
.copyright a {
  color: #999;
}

.copyright a {
  text-decoration: none;
}


a.back-to-top {
  position: fixed;
  z-index: 999;
  right: 0.75rem;
  bottom: 0.75rem;
  display: none;
  width: 2.625rem;
  height: 2.625rem;
  border-radius: 1.875rem;
  background: #333 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center 47%;
  background-size: 1.125rem 1.125rem;
  text-indent: -9999px;
}

a:hover.back-to-top {
  background-color: #555;
}


.ex-header {
  padding-top: 8rem;
  padding-bottom: 5rem;
  background-color: #f7fafd;
  text-align: center;
}

.ex-temel {
  padding-top: 2rem;
  padding-bottom: 0.875rem;
  background-color: #e8eff6;
}

.ex-temel .breadcrumbs {
  margin-bottom: 1.125rem;
}

.ex-temel .breadcrumbs .fa {
  margin-right: 0.5rem;
  margin-left: 0.625rem;
  font-size: 0.875rem;
}

.ex-basic-2 {
  padding-top: 4.75rem;
  padding-bottom: 4rem;
  background-color: #f7fafd;
}

.ex-basic-2 h3 {
  margin-bottom: 1rem;
}

.ex-basic-2 .metin-kutusu {
  margin-bottom: 3.625rem;
}

.ex-basic-2 .metin-kutusu.last {
  margin-bottom: 0;
}

.ex-basic-2 .metin-kutusu.dark {
  padding: 1.625rem 1.5rem 0.75rem 2rem;
  background-color: #e8eff6;
}

.ex-basic-2 .resim-kutusu-large {
  margin-bottom: 4rem;
}

.ex-basic-2 .resim-kutusu-large img {
  border-radius: 0.375rem;
}

.ex-basic-2 .resim-kutusu-small img {
  border-radius: 0.375rem;
}

.ex-basic-2 .liste-stili .fas {
  color: #777;
  font-size: 0.5rem;
  line-height: 1.75rem;
}

.ex-basic-2 .liste-stili .media-body {
  margin-left: 0.625rem;
}

.ex-basic-2 .form-container {
  margin-top: 3rem;
}

.ex-basic-2 .genel-buton-solid {
  margin-top: 1.5rem;
}


@media (min-width: 768px) {
  .header .metin-kutusu {
    margin-bottom: 6rem;
  }

  .header .buton-buyuk {
    margin-bottom: 0;
    margin-left: 0;
  }
  .kart-1 .card {
    display: inline-block;
    margin-right: 1rem;
    margin-left: 1rem;
    width: 11rem;
    max-width: 100%;
    vertical-align: top;
  }
  .tabs .nav-item {
    width: auto;
    margin-right: 0.625rem;
  }
  .slider .swiper-button-prev {
    left: -0.625rem;
  }

  .slider .swiper-button-next {
    right: -0.625rem;
  }
  .basic-3 .buton-buyuk {
    margin-bottom: 0;
    margin-left: 0;
  }
  .ex-header {
    padding-top: 11rem;
    padding-bottom: 9rem;
  }

  .ex-basic-2 .metin-kutusu.dark {
    padding: 2.5rem 3rem 2rem 3rem;
  }

  .ex-basic-2 .form-container {
    margin-top: 0;
  }
}
@media (min-width: 992px) {
  .p-baslik {
    width: 80%;
    margin-right: auto;
    margin-left: auto;
  }

  h1 {
    font-size: 3rem;
    line-height: 3.875rem;
  }

  h2 {
    font-size: 2.5rem;
    line-height: 3.25rem;
  }

  .ustmenu-default {
    padding: 2.125rem 1.5rem 2.125rem 2rem;
    background: transparent;
    box-shadow: none;
  }

  .ustmenu-default .navbar-nav {
    margin-top: 0;
    margin-bottom: 0;
  }

  .ustmenu-default .nav-item .nav-link {
    padding: 0.25rem 0.75rem;
  }
  .navbar-dark .navbar-nav .nav-link:focus {
    color: #777777;
  }
  .ustmenu-default.top-nav-collapse {
    padding: 0.5rem 1.5rem 0.5rem 2rem;
    background-color: #f7fafd;
    box-shadow: 0 0.0625rem 0.375rem 0 rgba(0, 0, 0, 0.1);
  }

  .ustmenu-default.top-nav-collapse .nav-item .nav-link {
    color: #333;
  }

  .ustmenu-default.top-nav-collapse .nav-item .nav-link:hover,
  .ustmenu-default.top-nav-collapse .nav-item .nav-link.active {
    color: #ff556e;
  }

  .ustmenu-default .dropdown-menu {
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-top: 0.75rem solid rgba(0, 0, 0, 0);
    border-radius: 0.25rem;
    box-shadow: 0 0.375rem 0.375rem 0 rgba(0, 0, 0, 0.1);
  }

  .ustmenu-default.top-nav-collapse .dropdown-menu {
    border-top: 0.75rem solid rgba(0, 0, 0, 0);
    box-shadow: 0 0.375rem 0.375rem 0 rgba(0, 0, 0, 0.1);
  }

  .ustmenu-default .dropdown-item {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .ustmenu-default .dropdown-divider {
    width: 84%;
  }

  .ustmenu-default .nav-item .buton-cizgili-kucuk {
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 0.625rem;
  }
  .header {
    padding-top: 12rem;
  }

  .header h1 {
    font-size: 4rem;
    line-height: 4.875rem;
    letter-spacing: -1px;
  }

  .header .beyaz-halka {
    position: absolute;
    top: 26rem;
    left: -12rem;
    display: block;
    width: 22rem;
    height: 22rem;
  }

  .header .beyaz-halka-2 {
    position: absolute;
    top: 19rem;
    right: -12rem;
    display: block;
    width: 20rem;
    height: 20rem;
  }

  .header .mavi-halka {
    position: absolute;
    top: 28rem;
    left: 5rem;
    display: block;
    width: 5rem;
    height: 5rem;
  }

  .header .sari-halka {
    position: absolute;
    top: 9rem;
    right: 7rem;
    display: block;
    width: 1.5rem;
    height: 1.5rem;
  }

  .header .gr-dia-halka {
    position: absolute;
    top: 9rem;
    left: 4rem;
    display: block;
    width: 1rem;
    height: 1rem;
  }
  .temel .resim-kutusu {
    margin-bottom: 0;
  }
  .basit-acik-kutu {
    padding: 3rem 3rem;
  }

  .basit-acik-kutu .resim-kutusu {
    margin-bottom: 0;
    text-align: left;
  }
  .tabs .tabs-container {
    margin-bottom: 0;
  }
  .basic-2 {
    padding-bottom: 8rem;
  }

  .basic-2 .liste-stili {
    margin-top: 2.5rem;
  }

  .basic-2 .li-buyuk-bosluk li {
    margin-bottom: 1.875rem;
  }

  .basic-2 .li-buyuk-bosluk.first li:last-of-type {
    margin-bottom: 1.875rem;
  }

  .basic-2 .fa-stack {
    margin-right: 1rem;
    font-size: 2.25rem;
  }

  .basic-2 .fa-stack .fa-stack-1x {
    font-size: 1.75rem;
  }

  .basic-2 .first .fa-stack {
    position: absolute;
    right: 0;
  }

  .basic-2 .first .media-body {
    max-width: 12.625rem;
    text-align: right;
  }

  .basic-2 img {
    max-width: 100%;
    margin-bottom: 0;
  }
  .slider .swiper-button-prev {
    left: 0;
  }

  .slider .swiper-button-next {
    right: 0;
  }
  .cards-2 .card {
    display: inline-block;
    width: 18.125rem;
    max-width: 100%;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    vertical-align: top;
  }

  .cards-2 .card:first-of-type {
    margin-left: 0;
  }

  .cards-2 .card:last-of-type {
    margin-right: 0;
  }
  .counter #counter .cell {
    width: 8.25rem;
  }

  .counter #counter .fas {
    font-size: 3rem;
  }

  .counter #counter .counter-value {
    font-size: 4rem;
    line-height: 4.875rem;
  }
  .basic-3 .buyuk-baslik {
    width: 51rem;
    margin-right: auto;
    margin-left: auto;
  }

  .basic-3 .beyaz-halka {
    position: absolute;
    top: 23rem;
    left: -12rem;
    display: block;
    width: 20rem;
    height: 20rem;
  }

  .basic-3 .beyaz-halka-2 {
    position: absolute;
    top: 7rem;
    right: -12.5rem;
    display: block;
    width: 20rem;
    height: 20rem;
  }

  .basic-3 .mavi-halka {
    position: absolute;
    top: 15rem;
    right: 5rem;
    display: block;
    width: 5rem;
    height: 5rem;
  }

  .basic-3 .sari-halka {
    position: absolute;
    top: 31rem;
    left: 6.5rem;
    display: block;
    width: 2.5rem;
    height: 2.5rem;
  }

  .basic-3 .gr-dia-halka {
    position: absolute;
    top: 8rem;
    right: 12.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
  }
  .footer .footer-col.first {
    display: none;
  }

  .footer .footer-col.third,
  .footer .footer-col.fourth {
    width: 11.5rem;
  }
  .ex-header h1 {
    width: 80%;
    margin-right: auto;
    margin-left: auto;
  }

  .ex-basic-2 {
    padding-bottom: 5rem;
  }
}

@media (min-width: 1200px) {
  .header .resim-kutusu {
    width: 58.0625rem;
    height: 36.125rem;
    margin-right: auto;
    margin-left: auto;
  }

  .header .beyaz-halka {
    top: 14rem;
    left: -27rem;
    width: 40rem;
    height: 40rem;
  }

  .header .beyaz-halka-2 {
    right: -15rem;
    width: 25.5rem;
    height: 25.5rem;
  }

  .header .mavi-halka {
    top: 29rem;
    left: 10rem;
    width: 6rem;
    height: 6rem;
  }

  .header .sari-halka {
    top: 13.5rem;
    right: 8%;
    width: 2.5rem;
    height: 2.5rem;
  }

  .header .gr-dia-halka {
    top: 7rem;
    left: 18%;
    width: 1.25rem;
    height: 1.25rem;
  }
  .kart-1 .card:first-of-type {
    margin-left: 0;
  }

  .kart-1 .card:last-of-type {
    margin-right: 0;
  }
  .temel .resim-kutusu {
    margin-right: 2.5rem;
    width: 31.0625rem;
    height: 36.625rem;
  }

  .temel .metin-kutusu {
    margin-top: 5rem;
    margin-left: 2.5rem;
  }
  .basit-acik-kutu .resim-kutusu {
    margin-right: 1.5rem;
  }
  .tabs .resim-kutusu {
    margin-left: 2.5rem;
    width: 31.0625rem;
    height: 36.625rem;
  }

  .tabs .tabs-container {
    margin-top: 6rem;
    margin-right: 2.5rem;
  }
  .basic-2 .liste-stili {
    margin-top: 4.5rem;
  }

  .basic-2 .li-buyuk-bosluk li {
    margin-bottom: 2.875rem;
  }

  .basic-2 .first .media-body {
    max-width: 16.375rem;
    margin-right: 5.75rem;
    margin-left: auto;
  }

  .basic-2 img {
    width: 18.75rem;
    height: 39.8125rem;
  }
  .slider .swiper-container {
    width: 100%;
  }

  .slider .swiper-button-prev {
    left: -2.25rem;
    width: 1.375rem;
    background-size: 1.375rem 2.125rem;
  }

  .slider .swiper-button-next {
    right: -2.25rem;
    width: 1.375rem;
    background-size: 1.375rem 2.125rem;
  }
  .cards-2 .card {
    width: 21rem;
    margin-right: 1.375rem;
    margin-left: 1.375rem;
  }

  .cards-2 .resim-kutusu img {
    margin-right: 1.25rem;
    margin-left: 1.25rem;
  }
  .counter #counter .cell {
    margin-right: 2.375rem;
    margin-left: 2.375rem;
  }
  .basic-3 .resim-kutusu {
    width: 40.8125rem;
    height: 36.0625rem;
    margin-right: auto;
    margin-left: auto;
  }

  #anaResim {
    max-width: 45rem;
  }
  .basic-3 .beyaz-halka {
    top: 20rem;
    left: -18rem;
    width: 30rem;
    height: 30rem;
  }

  .basic-3 .beyaz-halka-2 {
    top: 3rem;
    right: -20rem;
    width: 30rem;
    height: 30rem;
  }

  .basic-3 .mavi-halka {
    top: 17rem;
    right: 7rem;
    width: 6rem;
    height: 6rem;
  }

  .basic-3 .sari-halka {
    top: 33rem;
    left: 10rem;
    width: 3.5rem;
    height: 3.5rem;
  }

  .basic-3 .gr-dia-halka {
    top: 5rem;
    right: 25%;
    width: 1.5rem;
    height: 1.5rem;
  }

  .footer .footer-col.first {
    display: inline-block;
    width: 14rem;
    margin-right: 2.5rem;
  }

  .footer .footer-col.second {
    width: 14rem;
    margin-right: 2.25rem;
  }

  .footer .footer-col.third,
  .footer .footer-col.fourth {
    width: 8.5rem;
    margin-right: 3.25rem;
  }

  .footer .fa-stack:last-of-type {
    margin-right: 0;
  }

  .footer .footer-col.fifth {
    width: 12rem;
    margin-right: 0;
  }

  .ex-header h1 {
    width: 60%;
    margin-right: auto;
    margin-left: auto;
  }

  .ex-basic-2 .form-container {
    margin-left: 1.75rem;
  }

  .ex-basic-2 .resim-kutusu-small {
    margin-left: 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/styles.css"],"names":[],"mappings":";AACA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,4CAA4C;EAC5C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,4CAA4C;EAC5C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,4CAA4C;EAC5C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;;AAGA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,4CAA4C;EAC5C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,UAAU;EACV,6BAA6B;EAG7B,mEAAmE;AACrE;;AAEA;EACE,UAAU;EAGV,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EAGV,oEAAoE;AACtE;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAWA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EAEE,sBAAsB;AACxB;;AAWA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EAEE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EAEzB,wDAAwD;AAC1D;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EAEE,uBAAuB;AACzB;;AAaA;EACE;;;IAKE,mBAAmB;EACrB;EACA;IAGE,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;EACrD,mDAAmD;EACnD,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;AACf;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yDAAoR;EACpR,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,yDAAoR;EACpR,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;AACf;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6EAA8E;EAC9E,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,sCAAsC;IACtC,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,qDAAqD;EACvD;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,0CAA0C;IAC1C,sBAAsB;IACtB,oDAAoD;EACtD;;EAEA;IACE,0CAA0C;IAC1C,oDAAoD;EACtD;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,cAAc;IACd,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,SAAS;IACT,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kCAAkC;EACpC;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,SAAS;IACT,aAAa;IACb,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;IACX,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;;IAEE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["\nbody,\nhtml {\n  width: 100%;\n  height: 100%;\n}\n\nbody,\np {\n  color: #777;\n  font: 400 1rem/1.75rem \"Open Sans\", sans-serif;\n}\n\n.buyuk-baslik {\n  font: 400 1.125rem/1.875rem \"Open Sans\", sans-serif;\n}\n\n.kucuk-baslik {\n  font: 400 0.875rem/1.5rem \"Open Sans\", sans-serif;\n}\n\n.p-baslik {\n  margin-bottom: 4rem;\n  text-align: center;\n}\n\nh1 {\n  color: #333;\n  font: 700 2.625rem/3.375rem \"Open Sans\", sans-serif;\n}\n\nh2 {\n  color: #333;\n  font: 700 2.125rem/2.75rem \"Open Sans\", sans-serif;\n}\n\nh3 {\n  color: #333;\n  font: 700 1.75rem/2.375rem \"Open Sans\", sans-serif;\n}\n\nh4 {\n  color: #333;\n  font: 700 1.25rem/1.75rem \"Open Sans\", sans-serif;\n}\n\nh5 {\n  color: #333;\n  font: 700 1.125rem/1.625rem \"Open Sans\", sans-serif;\n}\n\nh6 {\n  color: #333;\n  font: 700 1rem/1.5rem \"Open Sans\", sans-serif;\n}\n\n.gelistirici-yorumlari {\n  font-style: italic;\n}\n\n.gelistici-ismi {\n  font-weight: 700;\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.li-buyuk-bosluk li {\n  margin-bottom: 0.625rem;\n}\n\na {\n  color: #555;\n  text-decoration: underline;\n}\n\na:hover {\n  color: #555;\n  text-decoration: underline;\n}\n\na.red {\n  color: #ff556e;\n}\n\n.genel-buton-solid {\n  display: inline-block;\n  padding: 1.1875rem 2.125rem 1.1875rem 2.125rem;\n  border: 0.125rem solid #ff556e;\n  border-radius: 2rem;\n  background-color: #ff556e;\n  color: #fff;\n  font: 700 0.875rem/0 \"Open Sans\", sans-serif;\n  text-decoration: none;\n  transition: all 0.2s;\n}\n\n.genel-buton-solid:hover {\n  border: 0.125rem solid #ff556e;\n  background-color: transparent;\n  color: #ff556e;\n  text-decoration: none;\n}\n\n.buton-buyuk {\n  display: inline-block;\n  padding: 1.5rem 2.375rem 1.5rem 2.375rem;\n  border: 0.125rem solid #ff556e;\n  border-radius: 2rem;\n  background-color: #ff556e;\n  color: #fff;\n  font: 700 0.875rem/0 \"Open Sans\", sans-serif;\n  text-decoration: none;\n  transition: all 0.2s;\n}\n\n.buton-buyuk:hover {\n  border: 0.125rem solid #ff556e;\n  background-color: transparent;\n  color: #ff556e;\n  text-decoration: none;\n}\n\n.buton-buyuk .fab {\n  margin-right: 0.5rem;\n  font-size: 1.25rem;\n  line-height: 0;\n  vertical-align: top;\n}\n\n.buton-buyuk .fab.fa-google-play {\n  font-size: 1rem;\n}\n\n.buton-cizgili {\n  display: inline-block;\n  padding: 1.1875rem 2.125rem 1.1875rem 2.125rem;\n  border: 0.125rem solid #333;\n  border-radius: 2rem;\n  background-color: transparent;\n  color: #333;\n  font: 700 0.875rem/0 \"Open Sans\", sans-serif;\n  text-decoration: none;\n  transition: all 0.2s;\n}\n\n.buton-cizgili:hover {\n  border: 0.125rem solid #333;\n  background-color: #333;\n  color: #fff;\n  text-decoration: none;\n}\n\n\n.buton-cizgili-kucuk {\n  display: inline-block;\n  padding: 1rem 1.5rem 1rem 1.5rem;\n  border: 0.125rem solid #333;\n  border-radius: 2rem;\n  background-color: transparent;\n  color: #333;\n  font: 700 0.875rem/0 \"Open Sans\", sans-serif;\n  text-decoration: none;\n  transition: all 0.2s;\n}\n\n.buton-cizgili-kucuk:hover {\n  border: 0.125rem solid #333;\n  background-color: #333;\n  color: #fff;\n  text-decoration: none;\n}\n\n.form-group {\n  position: relative;\n  margin-bottom: 1.25rem;\n}\n\n.form-group.has-error.has-danger {\n  margin-bottom: 0.625rem;\n}\n\n\n.my-mfp-slide-bottom .zoom-anim-dialog {\n  opacity: 0;\n  transition: all 0.2s ease-out;\n  -webkit-transform: translateY(-1.25rem) perspective(37.5rem) rotateX(10deg);\n  -ms-transform: translateY(-1.25rem) perspective(37.5rem) rotateX(10deg);\n  transform: translateY(-1.25rem) perspective(37.5rem) rotateX(10deg);\n}\n\n.my-mfp-slide-bottom.mfp-ready .zoom-anim-dialog {\n  opacity: 1;\n  -webkit-transform: translateY(0) perspective(37.5rem) rotateX(0);\n  -ms-transform: translateY(0) perspective(37.5rem) rotateX(0);\n  transform: translateY(0) perspective(37.5rem) rotateX(0);\n}\n\n.my-mfp-slide-bottom.mfp-removing .zoom-anim-dialog {\n  opacity: 0;\n  -webkit-transform: translateY(-0.625rem) perspective(37.5rem) rotateX(10deg);\n  -ms-transform: translateY(-0.625rem) perspective(37.5rem) rotateX(10deg);\n  transform: translateY(-0.625rem) perspective(37.5rem) rotateX(10deg);\n}\n\n.my-mfp-slide-bottom.mfp-bg {\n  opacity: 0;\n  transition: opacity 0.2s ease-out;\n}\n\n.my-mfp-slide-bottom.mfp-ready.mfp-bg {\n  opacity: 0.8;\n}\n.my-mfp-slide-bottom.mfp-removing.mfp-bg {\n  opacity: 0;\n}\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  -webkit-animation: fadeIn 0.6s;\n  animation: fadeIn 0.6s;\n}\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation: fadeOut 0.8s;\n  animation: fadeOut 0.8s;\n}\n.spinner-wrapper {\n  position: fixed;\n  z-index: 999999;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #f7fafd;\n}\n\n.spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 3.75rem;\n  height: 1.25rem;\n  margin: -0.625rem 0 0 -1.875rem;\n  text-align: center;\n}\n\n.spinner > div {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 100%;\n  background-color: #ff556e;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.spinner .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.spinner .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes sk-bouncedelay {\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    -ms-transform: scale(0);\n    transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n.ustmenu-default {\n  background-color: #f7fafd;\n  box-shadow: 0 0.0625rem 0.375rem 0 rgba(0, 0, 0, 0.1);\n  font: 700 0.875rem/0.875rem \"Open Sans\", sans-serif;\n  transition: all 0.2s;\n}\n\n.ustmenu-default .navbar-brand.logo-image img {\n  width: 6.6875rem;\n  height: 2.25rem;\n}\n\n.ustmenu-default .navbar-brand.logo-text {\n  font: 700 2rem/1rem \"Open Sans\", sans-serif;\n  color: #333;\n  text-decoration: none;\n}\n\n.ustmenu-default .navbar-nav {\n  margin-top: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.ustmenu-default .nav-item .nav-link {\n  padding: 0.625rem 0.75rem;\n  color: #333;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.ustmenu-default .nav-item .nav-link:hover,\n.ustmenu-default .nav-item .nav-link.active {\n  color: #ff556e;\n}\n\n.ustmenu-default .dropdown:hover > .dropdown-menu {\n  display: block; \n  min-width: auto;\n  animation: fadeDropdown 0.2s; \n}\n\n@keyframes fadeDropdown {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.ustmenu-default .dropdown-toggle {\n  cursor: default;\n}\n\n.ustmenu-default .dropdown-toggle:focus {\n  outline: 0;\n}\n\n.ustmenu-default .dropdown-menu {\n  margin-top: 0;\n  border: none;\n  border-radius: 0.25rem;\n  background-color: #f7fafd;\n}\n\n.ustmenu-default .dropdown-item {\n  color: #333;\n  text-decoration: none;\n}\n\n.ustmenu-default .dropdown-item:hover {\n  background-color: #f7fafd;\n}\n\n.ustmenu-default .dropdown-item .item-text {\n  font: 700 0.875rem/0.875rem \"Open Sans\", sans-serif;\n}\n\n.ustmenu-default .dropdown-item:hover .item-text {\n  color: #ff556e;\n}\n\n.ustmenu-default .dropdown-divider {\n  width: 100%;\n  height: 1px;\n  margin: 0.75rem auto 0.725rem auto;\n  border: none;\n  background-color: #c4d8dc;\n  opacity: 0.2;\n}\n\n.ustmenu-default .nav-item .buton-cizgili-kucuk {\n  margin-top: 0.125rem;\n  margin-bottom: 1.375rem;\n  margin-left: 0.5rem;\n  border: 0.125rem solid #ff556e;\n  color: #ff556e;\n}\n\n.ustmenu-default .nav-item .buton-cizgili-kucuk:hover {\n  border: 0.125rem solid #ff556e;\n  background-color: #ff556e;\n  color: #fff;\n}\n\n.ustmenu-default .navbar-toggler {\n  padding: 0;\n  border: none;\n  color: #333;\n  font-size: 2rem;\n}\n\n.ustmenu-default\n  button[aria-expanded=\"false\"]\n  .ustmenu-ackapa-fw.fas.fa-times {\n  display: none;\n}\n\n.ustmenu-default\n  button[aria-expanded=\"false\"]\n  .ustmenu-ackapa-fw.fas.fa-bars {\n  display: inline-block;\n}\n\n.ustmenu-default\n  button[aria-expanded=\"true\"]\n  .ustmenu-ackapa-fw.fas.fa-bars {\n  display: none;\n}\n\n.ustmenu-default\n  button[aria-expanded=\"true\"]\n  .ustmenu-ackapa-fw.fas.fa-times {\n  display: inline-block;\n  margin-right: 0.125rem;\n}\n\n.header {\n  position: relative;\n  overflow: hidden;\n  padding-top: 8rem;\n  padding-bottom: 3rem;\n  background-color: #f7fafd;\n  text-align: center;\n}\n\n.header .metin-kutusu {\n  margin-bottom: 3rem;\n}\n\n.header h1 {\n  margin-bottom: 1rem;\n}\n\n.header .p-baslik {\n  margin-bottom: 2rem;\n}\n\n.header .buton-buyuk {\n  margin-right: 0.5rem;\n  margin-bottom: 1.125rem;\n  margin-left: 0.5rem;\n}\n\n.header .beyaz-halka,\n.header .beyaz-halka-2,\n.header .mavi-halka,\n.header .sari-halka,\n.header .gr-dia-halka {\n  display: none;\n}\n\n\n.kart-1 {\n  padding-top: 1rem;\n  padding-bottom: 2rem;\n  background-color: #f7fafd;\n  text-align: center;\n}\n\n.kart-1 .card {\n  max-width: 11rem;\n  margin-right: auto;\n  margin-bottom: 3rem;\n  margin-left: auto;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\n\n.kart-1 .kart-resmi {\n  width: 7.5rem;\n  height: 7.5rem;\n  margin-right: auto;\n  margin-bottom: 1.5rem;\n  margin-left: auto;\n  border-radius: 50%;\n  background-color: #ebe7fa;\n}\n\n.kart-1 .kart-resmi .fas {\n  color: #aa7eec;\n  font-size: 3.25rem;\n  line-height: 7.5rem;\n}\n\n.kart-1 .kart-resmi.green {\n  background-color: #daf4ef;\n}\n\n.kart-1 .kart-resmi.green .fas {\n  color: #19ca94;\n}\n\n.kart-1 .kart-resmi.red {\n  background-color: #f8e5ea;\n}\n\n.kart-1 .kart-resmi.red .fas {\n  color: #ff556e;\n}\n\n.kart-1 .kart-resmi.yellow {\n  background-color: #f8f1de;\n}\n\n.kart-1 .kart-resmi.yellow .fas {\n  color: #ffb30f;\n}\n\n.kart-1 .kart-resmi.blue {\n  background-color: #e1f2fa;\n}\n\n.kart-1 .kart-resmi.blue .fas {\n  color: #50b9e8;\n}\n\n.kart-1 .card-body {\n  padding: 0;\n}\n\n.kart-1 .card-title {\n  margin-bottom: 0.5rem;\n}\n\n\n.temel {\n  padding-top: 3rem;\n  padding-bottom: 8rem;\n  background-color: #f7fafd;\n}\n\n.temel .resim-kutusu {\n  margin-bottom: 5rem;\n}\n\n.temel h2 {\n  margin-bottom: 1.5rem;\n}\n\n.temel .liste-stili {\n  margin-bottom: 1.75rem;\n}\n\n.temel .liste-stili .fas {\n  color: #777;\n  font-size: 0.5rem;\n  line-height: 1.75rem;\n}\n\n.temel .liste-stili .media-body {\n  margin-left: 0.5rem;\n}\n\n.basit-acik-kutu {\n  position: relative;\n  max-width: 71.875rem;\n  margin: 2.5rem auto;\n  padding: 3rem 1rem;\n  background-color: #fff;\n  text-align: left;\n}\n\n.basit-acik-kutu .resim-kutusu {\n  margin-bottom: 3rem;\n  text-align: center;\n}\n\n.basit-acik-kutu h3 {\n  margin-bottom: 0.5rem;\n}\n\n.basit-acik-kutu hr {\n  width: 2.75rem;\n  margin-top: 0.125rem;\n  margin-bottom: 1rem;\n  margin-left: 0;\n  border-top: 0.125rem solid #e0e0e0;\n}\n\n.basit-acik-kutu h4 {\n  margin-top: 1.75rem;\n  margin-bottom: 0.625rem;\n}\n\n.basit-acik-kutu .liste-stili {\n  margin-bottom: 1.5rem;\n}\n\n.basit-acik-kutu .liste-stili .far {\n  color: #19ca94;\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.basit-acik-kutu .liste-stili .media-body {\n  margin-left: 0.625rem;\n}\n\n.basit-acik-kutu .liste-stili {\n  margin-bottom: 1.5rem;\n}\n\n.basit-acik-kutu .genel-buton-solid.mfp-close {\n  position: relative;\n  width: auto;\n  height: auto;\n  color: #fff;\n  opacity: 1;\n}\n\n.basit-acik-kutu .genel-buton-solid.mfp-close:hover {\n  color: #ff556e;\n}\n\n.tabs {\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n  background-color: #e8eff6;\n}\n\n.tabs .tabs-container {\n  margin-bottom: 5rem;\n}\n\n.tabs .nav-tabs {\n  margin-bottom: 1.125rem;\n  border: none;\n}\n\n.tabs .nav-item {\n  width: 100%;\n  margin-bottom: 0.75rem;\n  text-align: center;\n}\n\n.tabs .nav-link {\n  padding: 0.5rem 1.5rem;\n  border-radius: 0;\n  background-color: #f7fafd;\n  color: #777;\n  font-weight: 700;\n  font-size: 1.125rem;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.tabs .nav-link.active {\n  background-color: #9a67e7;\n  color: #fff;\n}\n\n.tabs .nav-link:hover {\n  background-color: #9a67e7;\n  color: #fff;\n}\n\n.tabs .nav-link .fas,\n.tabs .nav-link .far {\n  margin-right: 0.375rem;\n}\n\n.tabs .li-buyuk-bosluk li {\n  margin-bottom: 0.875rem;\n}\n\n.tabs .liste-stili .fas,\n.tabs .liste-stili .far {\n  color: #19ca94;\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.tabs .liste-stili .media-body {\n  margin-left: 0.625rem;\n}\n\n.tabs #tab-1 .liste-stili {\n  margin-bottom: 1.5rem;\n}\n\n.tabs #tab-1 .genel-buton-solid {\n  margin-right: 0.5rem;\n}\n\n\n.basic-2 {\n  padding-top: 7rem;\n  padding-bottom: 5rem;\n  background-color: #f7fafd;\n}\n\n.basic-2 h2 {\n  margin-bottom: 0.875rem;\n  text-align: center;\n}\n\n.basic-2 .li-buyuk-bosluk li {\n  margin-bottom: 1.375rem;\n}\n\n.basic-2 .li-buyuk-bosluk.first li:last-of-type {\n  margin-bottom: 4rem;\n}\n\n.basic-2 .fa-stack {\n  width: 2em;\n  margin-right: 0.625rem;\n  font-size: 1.25rem;\n}\n\n.basic-2 .fa-stack-2x {\n  color: #aa7eec;\n}\n\n.basic-2 .fa-stack-2x.green {\n  color: #19ca94;\n}\n\n.basic-2 .fa-stack-2x.red {\n  color: #ff556e;\n}\n\n.basic-2 .fa-stack-2x.yellow {\n  color: #ffb30f;\n}\n\n.basic-2 .fa-stack-2x.blue {\n  color: #50b9e8;\n}\n\n.basic-2 .fa-stack-1x {\n  color: #fff;\n}\n\n.basic-2 .media-body h4 {\n  margin-bottom: 0.25rem;\n}\n\n.basic-2 img {\n  display: block;\n  width: 100%;\n  max-width: 20rem;\n  margin-right: auto;\n  margin-bottom: 5rem;\n  margin-left: auto;\n}\n\n\n.slider {\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n  background-color: #e8eff6;\n}\n\n.slider .slider-container {\n  position: relative;\n}\n\n.slider .swiper-container {\n  position: static;\n  width: 90%;\n  text-align: center;\n}\n\n.slider .swiper-button-prev,\n.slider .swiper-button-next {\n  top: 50%;\n  width: 1.125rem;\n}\n\n.slider .swiper-button-prev:focus,\n.slider .swiper-button-next:focus {\n  outline: none;\n}\n\n.slider .swiper-button-prev {\n  left: -0.5rem;\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2028%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23777777'%2F%3E%3C%2Fsvg%3E\");\n  background-size: 1.125rem 1.75rem;\n}\n\n.slider .swiper-button-next {\n  right: -0.5rem;\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2028%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23777777'%2F%3E%3C%2Fsvg%3E\");\n  background-size: 1.125rem 1.75rem;\n}\n\n.cards-2 {\n  padding-top: 7rem;\n  padding-bottom: 3rem;\n  background-color: #f7fafd;\n  text-align: center;\n}\n\n.cards-2 h2 {\n  margin-bottom: 3.25rem;\n}\n\n.cards-2 .card {\n  max-width: 22rem;\n  margin-right: auto;\n  margin-bottom: 4.75rem;\n  margin-left: auto;\n  border: 0;\n  background-color: transparent;\n}\n\n.cards-2 .fa-star {\n  margin-right: 0.25rem;\n  color: #ffb30f;\n  font-size: 1.375rem;\n}\n\n.cards-2 .testimonial-line {\n  width: 3rem;\n  margin-bottom: 1rem;\n  border-top: 0.125rem solid #e0e0e0;\n}\n\n.cards-2 .card-body {\n  padding: 0;\n}\n\n.cards-2 .gelistirici-yorumlari {\n  margin-bottom: 0.625rem;\n}\n\n.cards-2 .gelistici-ismi {\n  color: #333;\n}\n\n.cards-2 .resim-kutusu {\n  margin-bottom: 5.25rem;\n  padding: 2.5rem 2rem 0 2rem;\n  border-radius: 0.5rem;\n  background-color: #fff;\n}\n\n.cards-2 .resim-kutusu img {\n  margin-right: 1rem;\n  margin-bottom: 2.5rem;\n  margin-left: 1rem;\n}\n\n\n.counter {\n  padding-top: 8rem;\n  padding-bottom: 5rem;\n  background-color: #e8eff6;\n  text-align: center;\n}\n\n.counter #counter {\n  margin-bottom: 0.75rem;\n}\n\n.counter #counter .cell {\n  display: inline-block;\n  width: 6.25rem;\n  margin-right: 1.5rem;\n  margin-bottom: 2rem;\n  margin-left: 1.5rem;\n  vertical-align: top;\n}\n\n.counter #counter .fas {\n  margin-bottom: 0.875rem;\n  font-size: 2.5rem;\n  color: #aa7eec;\n}\n\n.counter #counter .fas.green {\n  color: #19ca94;\n}\n\n.counter #counter .fas.red {\n  color: #ff556e;\n}\n\n.counter #counter .fas.yellow {\n  color: #ffb30f;\n}\n\n.counter #counter .fas.blue {\n  color: #50b9e8;\n}\n\n.counter #counter .counter-value {\n  color: #333;\n  font-weight: 700;\n  font-size: 3.5rem;\n  line-height: 4.25rem;\n  vertical-align: middle;\n}\n\n.counter #counter .counter-info {\n  margin-bottom: 0;\n  vertical-align: middle;\n}\n\n.basic-3 {\n  position: relative;\n  overflow: hidden;\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n  background-color: #f7fafd;\n  text-align: center;\n}\n\n.basic-3 .resim-kutusu {\n  margin-bottom: 2rem;\n}\n\n.basic-3 .buyuk-baslik {\n  margin-bottom: 1.75rem;\n}\n\n.basic-3 .buton-buyuk {\n  margin-right: 0.5rem;\n  margin-bottom: 1.125rem;\n  margin-left: 0.5rem;\n}\n\n.basic-3 .beyaz-halka,\n.basic-3 .beyaz-halka-2,\n.basic-3 .mavi-halka,\n.basic-3 .sari-halka,\n.basic-3 .gr-dia-halka {\n  display: none;\n}\n\n\n.footer {\n  padding-top: 4rem;\n  padding-bottom: 1rem;\n  border-top: 1px solid #c8d4d6;\n  background-color: #f7fafd;\n}\n\n.footer p,\n.footer h5,\n.footer ul,\n.footer a {\n  color: #999;\n}\n\n.footer a {\n  text-decoration: none;\n}\n\n.footer .footer-col {\n  display: inline-block;\n  width: 14.5rem;\n  margin-right: 1rem;\n  margin-bottom: 1.5rem;\n  vertical-align: top;\n}\n\n.footer h5 {\n  margin-bottom: 0.625rem;\n}\n\n.footer .li-buyuk-bosluk li {\n  margin-bottom: 0.375rem;\n}\n\n.footer .liste-stili .fab,\n.footer .liste-stili .fas {\n  width: 0.875rem;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n}\n\n.footer .liste-stili .media-body {\n  margin-left: 0.625rem;\n}\n\n.footer .fa-stack {\n  width: 2em;\n  margin-bottom: 0.75rem;\n  margin-right: 0.375rem;\n  font-size: 1.25rem;\n}\n\n.footer .fa-stack .fa-stack-1x {\n  color: #fff;\n  transition: all 0.2s ease;\n}\n\n.footer .fa-stack .fa-stack-2x {\n  color: #999;\n  transition: all 0.2s ease;\n}\n\n.footer .fa-stack:hover .fa-stack-1x {\n  color: #fff;\n}\n\n.footer .fa-stack:hover .fa-stack-2x {\n  color: #555;\n}\n\n\n.copyright {\n  padding-bottom: 0.75rem;\n  background-color: #f7fafd;\n  text-align: center;\n}\n\n.copyright p,\n.copyright a {\n  color: #999;\n}\n\n.copyright a {\n  text-decoration: none;\n}\n\n\na.back-to-top {\n  position: fixed;\n  z-index: 999;\n  right: 0.75rem;\n  bottom: 0.75rem;\n  display: none;\n  width: 2.625rem;\n  height: 2.625rem;\n  border-radius: 1.875rem;\n  background: #333 url(\"../../public//images/up-arrow.png\") no-repeat center 47%;\n  background-size: 1.125rem 1.125rem;\n  text-indent: -9999px;\n}\n\na:hover.back-to-top {\n  background-color: #555;\n}\n\n\n.ex-header {\n  padding-top: 8rem;\n  padding-bottom: 5rem;\n  background-color: #f7fafd;\n  text-align: center;\n}\n\n.ex-temel {\n  padding-top: 2rem;\n  padding-bottom: 0.875rem;\n  background-color: #e8eff6;\n}\n\n.ex-temel .breadcrumbs {\n  margin-bottom: 1.125rem;\n}\n\n.ex-temel .breadcrumbs .fa {\n  margin-right: 0.5rem;\n  margin-left: 0.625rem;\n  font-size: 0.875rem;\n}\n\n.ex-basic-2 {\n  padding-top: 4.75rem;\n  padding-bottom: 4rem;\n  background-color: #f7fafd;\n}\n\n.ex-basic-2 h3 {\n  margin-bottom: 1rem;\n}\n\n.ex-basic-2 .metin-kutusu {\n  margin-bottom: 3.625rem;\n}\n\n.ex-basic-2 .metin-kutusu.last {\n  margin-bottom: 0;\n}\n\n.ex-basic-2 .metin-kutusu.dark {\n  padding: 1.625rem 1.5rem 0.75rem 2rem;\n  background-color: #e8eff6;\n}\n\n.ex-basic-2 .resim-kutusu-large {\n  margin-bottom: 4rem;\n}\n\n.ex-basic-2 .resim-kutusu-large img {\n  border-radius: 0.375rem;\n}\n\n.ex-basic-2 .resim-kutusu-small img {\n  border-radius: 0.375rem;\n}\n\n.ex-basic-2 .liste-stili .fas {\n  color: #777;\n  font-size: 0.5rem;\n  line-height: 1.75rem;\n}\n\n.ex-basic-2 .liste-stili .media-body {\n  margin-left: 0.625rem;\n}\n\n.ex-basic-2 .form-container {\n  margin-top: 3rem;\n}\n\n.ex-basic-2 .genel-buton-solid {\n  margin-top: 1.5rem;\n}\n\n\n@media (min-width: 768px) {\n  .header .metin-kutusu {\n    margin-bottom: 6rem;\n  }\n\n  .header .buton-buyuk {\n    margin-bottom: 0;\n    margin-left: 0;\n  }\n  .kart-1 .card {\n    display: inline-block;\n    margin-right: 1rem;\n    margin-left: 1rem;\n    width: 11rem;\n    max-width: 100%;\n    vertical-align: top;\n  }\n  .tabs .nav-item {\n    width: auto;\n    margin-right: 0.625rem;\n  }\n  .slider .swiper-button-prev {\n    left: -0.625rem;\n  }\n\n  .slider .swiper-button-next {\n    right: -0.625rem;\n  }\n  .basic-3 .buton-buyuk {\n    margin-bottom: 0;\n    margin-left: 0;\n  }\n  .ex-header {\n    padding-top: 11rem;\n    padding-bottom: 9rem;\n  }\n\n  .ex-basic-2 .metin-kutusu.dark {\n    padding: 2.5rem 3rem 2rem 3rem;\n  }\n\n  .ex-basic-2 .form-container {\n    margin-top: 0;\n  }\n}\n@media (min-width: 992px) {\n  .p-baslik {\n    width: 80%;\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  h1 {\n    font-size: 3rem;\n    line-height: 3.875rem;\n  }\n\n  h2 {\n    font-size: 2.5rem;\n    line-height: 3.25rem;\n  }\n\n  .ustmenu-default {\n    padding: 2.125rem 1.5rem 2.125rem 2rem;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .ustmenu-default .navbar-nav {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .ustmenu-default .nav-item .nav-link {\n    padding: 0.25rem 0.75rem;\n  }\n  .navbar-dark .navbar-nav .nav-link:focus {\n    color: #777777;\n  }\n  .ustmenu-default.top-nav-collapse {\n    padding: 0.5rem 1.5rem 0.5rem 2rem;\n    background-color: #f7fafd;\n    box-shadow: 0 0.0625rem 0.375rem 0 rgba(0, 0, 0, 0.1);\n  }\n\n  .ustmenu-default.top-nav-collapse .nav-item .nav-link {\n    color: #333;\n  }\n\n  .ustmenu-default.top-nav-collapse .nav-item .nav-link:hover,\n  .ustmenu-default.top-nav-collapse .nav-item .nav-link.active {\n    color: #ff556e;\n  }\n\n  .ustmenu-default .dropdown-menu {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    border-top: 0.75rem solid rgba(0, 0, 0, 0);\n    border-radius: 0.25rem;\n    box-shadow: 0 0.375rem 0.375rem 0 rgba(0, 0, 0, 0.1);\n  }\n\n  .ustmenu-default.top-nav-collapse .dropdown-menu {\n    border-top: 0.75rem solid rgba(0, 0, 0, 0);\n    box-shadow: 0 0.375rem 0.375rem 0 rgba(0, 0, 0, 0.1);\n  }\n\n  .ustmenu-default .dropdown-item {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .ustmenu-default .dropdown-divider {\n    width: 84%;\n  }\n\n  .ustmenu-default .nav-item .buton-cizgili-kucuk {\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-left: 0.625rem;\n  }\n  .header {\n    padding-top: 12rem;\n  }\n\n  .header h1 {\n    font-size: 4rem;\n    line-height: 4.875rem;\n    letter-spacing: -1px;\n  }\n\n  .header .beyaz-halka {\n    position: absolute;\n    top: 26rem;\n    left: -12rem;\n    display: block;\n    width: 22rem;\n    height: 22rem;\n  }\n\n  .header .beyaz-halka-2 {\n    position: absolute;\n    top: 19rem;\n    right: -12rem;\n    display: block;\n    width: 20rem;\n    height: 20rem;\n  }\n\n  .header .mavi-halka {\n    position: absolute;\n    top: 28rem;\n    left: 5rem;\n    display: block;\n    width: 5rem;\n    height: 5rem;\n  }\n\n  .header .sari-halka {\n    position: absolute;\n    top: 9rem;\n    right: 7rem;\n    display: block;\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n\n  .header .gr-dia-halka {\n    position: absolute;\n    top: 9rem;\n    left: 4rem;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n  }\n  .temel .resim-kutusu {\n    margin-bottom: 0;\n  }\n  .basit-acik-kutu {\n    padding: 3rem 3rem;\n  }\n\n  .basit-acik-kutu .resim-kutusu {\n    margin-bottom: 0;\n    text-align: left;\n  }\n  .tabs .tabs-container {\n    margin-bottom: 0;\n  }\n  .basic-2 {\n    padding-bottom: 8rem;\n  }\n\n  .basic-2 .liste-stili {\n    margin-top: 2.5rem;\n  }\n\n  .basic-2 .li-buyuk-bosluk li {\n    margin-bottom: 1.875rem;\n  }\n\n  .basic-2 .li-buyuk-bosluk.first li:last-of-type {\n    margin-bottom: 1.875rem;\n  }\n\n  .basic-2 .fa-stack {\n    margin-right: 1rem;\n    font-size: 2.25rem;\n  }\n\n  .basic-2 .fa-stack .fa-stack-1x {\n    font-size: 1.75rem;\n  }\n\n  .basic-2 .first .fa-stack {\n    position: absolute;\n    right: 0;\n  }\n\n  .basic-2 .first .media-body {\n    max-width: 12.625rem;\n    text-align: right;\n  }\n\n  .basic-2 img {\n    max-width: 100%;\n    margin-bottom: 0;\n  }\n  .slider .swiper-button-prev {\n    left: 0;\n  }\n\n  .slider .swiper-button-next {\n    right: 0;\n  }\n  .cards-2 .card {\n    display: inline-block;\n    width: 18.125rem;\n    max-width: 100%;\n    margin-right: 0.5rem;\n    margin-left: 0.5rem;\n    vertical-align: top;\n  }\n\n  .cards-2 .card:first-of-type {\n    margin-left: 0;\n  }\n\n  .cards-2 .card:last-of-type {\n    margin-right: 0;\n  }\n  .counter #counter .cell {\n    width: 8.25rem;\n  }\n\n  .counter #counter .fas {\n    font-size: 3rem;\n  }\n\n  .counter #counter .counter-value {\n    font-size: 4rem;\n    line-height: 4.875rem;\n  }\n  .basic-3 .buyuk-baslik {\n    width: 51rem;\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .basic-3 .beyaz-halka {\n    position: absolute;\n    top: 23rem;\n    left: -12rem;\n    display: block;\n    width: 20rem;\n    height: 20rem;\n  }\n\n  .basic-3 .beyaz-halka-2 {\n    position: absolute;\n    top: 7rem;\n    right: -12.5rem;\n    display: block;\n    width: 20rem;\n    height: 20rem;\n  }\n\n  .basic-3 .mavi-halka {\n    position: absolute;\n    top: 15rem;\n    right: 5rem;\n    display: block;\n    width: 5rem;\n    height: 5rem;\n  }\n\n  .basic-3 .sari-halka {\n    position: absolute;\n    top: 31rem;\n    left: 6.5rem;\n    display: block;\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n\n  .basic-3 .gr-dia-halka {\n    position: absolute;\n    top: 8rem;\n    right: 12.5rem;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n  }\n  .footer .footer-col.first {\n    display: none;\n  }\n\n  .footer .footer-col.third,\n  .footer .footer-col.fourth {\n    width: 11.5rem;\n  }\n  .ex-header h1 {\n    width: 80%;\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .ex-basic-2 {\n    padding-bottom: 5rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .header .resim-kutusu {\n    width: 58.0625rem;\n    height: 36.125rem;\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .header .beyaz-halka {\n    top: 14rem;\n    left: -27rem;\n    width: 40rem;\n    height: 40rem;\n  }\n\n  .header .beyaz-halka-2 {\n    right: -15rem;\n    width: 25.5rem;\n    height: 25.5rem;\n  }\n\n  .header .mavi-halka {\n    top: 29rem;\n    left: 10rem;\n    width: 6rem;\n    height: 6rem;\n  }\n\n  .header .sari-halka {\n    top: 13.5rem;\n    right: 8%;\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n\n  .header .gr-dia-halka {\n    top: 7rem;\n    left: 18%;\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n  .kart-1 .card:first-of-type {\n    margin-left: 0;\n  }\n\n  .kart-1 .card:last-of-type {\n    margin-right: 0;\n  }\n  .temel .resim-kutusu {\n    margin-right: 2.5rem;\n    width: 31.0625rem;\n    height: 36.625rem;\n  }\n\n  .temel .metin-kutusu {\n    margin-top: 5rem;\n    margin-left: 2.5rem;\n  }\n  .basit-acik-kutu .resim-kutusu {\n    margin-right: 1.5rem;\n  }\n  .tabs .resim-kutusu {\n    margin-left: 2.5rem;\n    width: 31.0625rem;\n    height: 36.625rem;\n  }\n\n  .tabs .tabs-container {\n    margin-top: 6rem;\n    margin-right: 2.5rem;\n  }\n  .basic-2 .liste-stili {\n    margin-top: 4.5rem;\n  }\n\n  .basic-2 .li-buyuk-bosluk li {\n    margin-bottom: 2.875rem;\n  }\n\n  .basic-2 .first .media-body {\n    max-width: 16.375rem;\n    margin-right: 5.75rem;\n    margin-left: auto;\n  }\n\n  .basic-2 img {\n    width: 18.75rem;\n    height: 39.8125rem;\n  }\n  .slider .swiper-container {\n    width: 100%;\n  }\n\n  .slider .swiper-button-prev {\n    left: -2.25rem;\n    width: 1.375rem;\n    background-size: 1.375rem 2.125rem;\n  }\n\n  .slider .swiper-button-next {\n    right: -2.25rem;\n    width: 1.375rem;\n    background-size: 1.375rem 2.125rem;\n  }\n  .cards-2 .card {\n    width: 21rem;\n    margin-right: 1.375rem;\n    margin-left: 1.375rem;\n  }\n\n  .cards-2 .resim-kutusu img {\n    margin-right: 1.25rem;\n    margin-left: 1.25rem;\n  }\n  .counter #counter .cell {\n    margin-right: 2.375rem;\n    margin-left: 2.375rem;\n  }\n  .basic-3 .resim-kutusu {\n    width: 40.8125rem;\n    height: 36.0625rem;\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  #anaResim {\n    max-width: 45rem;\n  }\n  .basic-3 .beyaz-halka {\n    top: 20rem;\n    left: -18rem;\n    width: 30rem;\n    height: 30rem;\n  }\n\n  .basic-3 .beyaz-halka-2 {\n    top: 3rem;\n    right: -20rem;\n    width: 30rem;\n    height: 30rem;\n  }\n\n  .basic-3 .mavi-halka {\n    top: 17rem;\n    right: 7rem;\n    width: 6rem;\n    height: 6rem;\n  }\n\n  .basic-3 .sari-halka {\n    top: 33rem;\n    left: 10rem;\n    width: 3.5rem;\n    height: 3.5rem;\n  }\n\n  .basic-3 .gr-dia-halka {\n    top: 5rem;\n    right: 25%;\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n\n  .footer .footer-col.first {\n    display: inline-block;\n    width: 14rem;\n    margin-right: 2.5rem;\n  }\n\n  .footer .footer-col.second {\n    width: 14rem;\n    margin-right: 2.25rem;\n  }\n\n  .footer .footer-col.third,\n  .footer .footer-col.fourth {\n    width: 8.5rem;\n    margin-right: 3.25rem;\n  }\n\n  .footer .fa-stack:last-of-type {\n    margin-right: 0;\n  }\n\n  .footer .footer-col.fifth {\n    width: 12rem;\n    margin-right: 0;\n  }\n\n  .ex-header h1 {\n    width: 60%;\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .ex-basic-2 .form-container {\n    margin-left: 1.75rem;\n  }\n\n  .ex-basic-2 .resim-kutusu-small {\n    margin-left: 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
